import { Link } from 'react-router-dom';

import { ROUTES } from '@/config/routes';
import { useSaasStore } from '@/stores/saas-store';
import { CircleDot } from 'lucide-react';

import { Facebook, Youtube } from '../ui/social-icons';

export default function Footer() {
  const referralEnabled = useSaasStore(s => s.referralEnabled);
  return (
    <footer className='bg-slate-900 text-slate-300 px-6 py-16'>
      <div className='max-w-7xl mx-auto'>
        <div className='grid md:grid-cols-4 gap-12 mb-12'>
          {/* Logo + Description */}
          <div>
            <Link to={ROUTES.HOME} className='flex items-center gap-2 mb-4'>
              <div className='w-10 h-10 bg-blue-600 rounded-xl flex items-center justify-center shadow-lg'>
                <CircleDot className='text-white w-6 h-6' />
              </div>
              <span className='text-xl font-extrabold tracking-tight text-white'>
                Boules<span className='text-blue-400'>Connect</span>
              </span>
            </Link>
            <p className='text-sm text-slate-400 leading-relaxed'>
              La plateforme SaaS qui digitalise les compétitions de pétanque, provençal et boule lyonnaise.
            </p>
          </div>

          {/* Produit */}
          <div>
            <h4 className='font-bold text-white mb-4'>Produit</h4>
            <ul className='space-y-2 text-sm'>
              <li>
                <Link to={ROUTES.FONCTIONNALITES} className='hover:text-white transition'>
                  Fonctionnalités
                </Link>
              </li>
              <li>
                <Link to={ROUTES.TARIFS} className='hover:text-white transition'>
                  Tarifs
                </Link>
              </li>
              <li>
                <Link to={ROUTES.COMMENT_CA_MARCHE} className='hover:text-white transition'>
                  Comment ça marche
                </Link>
              </li>
              <li>
                <Link to={ROUTES.PLV} className='hover:text-white transition'>
                  Ressources médias
                </Link>
              </li>
              {referralEnabled && (
                <li>
                  <Link to={ROUTES.PARRAINAGE} className='hover:text-white transition'>
                    Parrainage
                  </Link>
                </li>
              )}
            </ul>
          </div>

          {/* Entreprise */}
          <div>
            <h4 className='font-bold text-white mb-4'>Entreprise</h4>
            <ul className='space-y-2 text-sm'>
              <li>
                <Link to={ROUTES.A_PROPOS} className='hover:text-white transition'>
                  À propos
                </Link>
              </li>
              <li>
                <Link to={ROUTES.BLOG} className='hover:text-white transition'>
                  Blog
                </Link>
              </li>
              <li>
                <Link to={ROUTES.CONTACT} className='hover:text-white transition'>
                  Nous contacter
                </Link>
              </li>
              <li>
                <Link to={ROUTES.SUPPORT} className='hover:text-white transition'>
                  Centre d'aide
                </Link>
              </li>
            </ul>
          </div>

          {/* Légal */}
          <div>
            <h4 className='font-bold text-white mb-4'>Légal</h4>
            <ul className='space-y-2 text-sm'>
              <li>
                <Link to={ROUTES.MENTIONS_LEGALES} className='hover:text-white transition'>
                  Mentions légales
                </Link>
              </li>
              <li>
                <Link to={ROUTES.CGU_CGV} className='hover:text-white transition'>
                  CGU & CGV
                </Link>
              </li>
              <li>
                <Link to={ROUTES.POLITIQUE_RGPD} className='hover:text-white transition'>
                  Politique RGPD
                </Link>
              </li>
              <li>
                <Link to={ROUTES.COOKIES} className='hover:text-white transition'>
                  Cookies
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className='border-t border-slate-800 pt-8 flex flex-col md:flex-row items-center justify-between gap-4'>
          <p className='text-sm text-slate-500'>© 2026 BoulesConnect. Tous droits réservés.</p>
          <div className='flex items-center gap-6'>
            <a
              href={'https://www.facebook.com/boulesconnect/'}
              target={'_blank'}
              rel={'noopener'}
              className='text-slate-400 hover:text-white transition'
            >
              <Facebook className='w-5 h-5' />
            </a>
            <a
              href='https://www.youtube.com/@BoulesConnect'
              target={'_blank'}
              rel='noopener noreferrer'
              className='text-slate-400 hover:text-white transition'
            >
              <Youtube className='w-5 h-5' />
            </a>
            {/*<a href='#' className='text-slate-400 hover:text-white transition'>*/}
            {/*  <Instagram className='w-5 h-5' />*/}
            {/*</a>*/}
            {/*<a href='#' className='text-slate-400 hover:text-white transition'>*/}
            {/*  <Linkedin className='w-5 h-5' />*/}
            {/*</a>*/}
            {/*<a href='#' className='text-slate-400 hover:text-white transition'>*/}
            {/*  <Twitter className='w-5 h-5' />*/}
            {/*</a>*/}
          </div>
        </div>
      </div>
    </footer>
  );
}
